import condition from "@groq/fragments/condition";

const conditionQuery = `condition->
${condition}     
`;

export default conditionQuery;
